var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamingPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 430,
    viewBox: "0 0 488 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_334)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M62.2866 248.027C67.3252 232.365 76.2171 217.98 79.5964 201.893C81.3641 193.481 81.6003 184.712 84.1888 176.531C88.5623 162.818 99.4723 151.791 112.245 145.178C125.018 138.564 139.579 136.006 153.967 135.452C158.981 135.258 164.08 135.29 168.937 134.052C177.916 131.746 185.241 125.409 192.031 119.091C221.01 92.097 250.567 60.1897 289.927 55.8017C318.648 52.5981 346.541 65.0307 372.769 77.1951C388.623 84.5388 405.048 92.3207 416.058 105.893C425.949 118.081 430.41 133.661 434.643 148.775L452.343 211.984C452.83 213.409 453.069 214.908 453.051 216.414C452.814 219.657 450.262 222.212 447.758 224.294C433.501 236.017 415.621 242.222 398.155 248.202L133.68 338.724C122.399 342.586 98.4232 354.934 86.3571 351.895C86.3571 351.895 74.8889 335.325 70.7282 327.836C57.3859 303.848 53.8436 274.269 62.2866 248.027Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M455.603 211.427C461.542 227.216 460.964 244.718 453.998 260.081C447.032 275.445 434.249 287.412 418.459 293.35L167.748 387.638C151.959 393.575 134.459 392.996 119.096 386.03C103.734 379.064 91.7674 366.281 85.8297 350.492L455.603 211.427Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.355 211.52C455.953 214.535 453.909 218.768 451.541 221.426C444.686 229.101 437.374 236.355 429.645 243.148C422.942 249.032 415.801 254.646 407.521 257.958C401.202 260.49 394.432 261.596 387.746 262.938C318.627 276.826 257.242 316.703 188.931 334.148C186.757 334.703 183.985 336.8 185.445 338.505C184.431 337.318 162.537 346.387 159.991 347.264C152.495 349.843 144.968 353.005 137.233 354.806C125.975 357.433 110.244 349.888 100.21 345.261C100.21 345.261 115.73 339.917 122.617 336.657L455.355 211.52Z",
    fill: "url(#paint0_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.577 152.748C380.618 151.214 378.439 149.078 379.061 146.676C379.533 144.854 381.503 143.701 381.898 141.861C376.876 143.214 372.192 138.834 369.376 134.463C365.217 127.962 362.414 120.687 361.136 113.075C359.857 105.463 360.13 97.6715 361.938 90.1678C362.131 89.3992 362.398 88.5437 363.156 88.2374C364.061 87.8969 364.993 88.58 365.676 89.2439C372.688 95.7412 379.322 102.636 385.543 109.894C386.108 110.555 386.705 111.331 386.594 112.176C386.447 112.8 386.118 113.366 385.647 113.801L381.409 118.549L389.39 115.183C391.325 118.691 393.279 122.234 394.399 126.081C395.067 128.384 394.895 131.672 392.526 132.177C394.383 131.548 395.963 133.599 396.867 135.363L408.856 158.698C409.258 159.484 409.666 160.396 409.321 161.201C409.044 161.888 408.26 162.253 407.564 162.552C402.804 164.589 400.734 166.331 396.377 163.546C391.69 160.565 387.663 155.054 382.577 152.748Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.577 152.748C380.618 151.214 378.439 149.078 379.061 146.676C379.533 144.854 381.503 143.701 381.898 141.861C376.876 143.214 372.192 138.834 369.376 134.463C365.217 127.962 362.414 120.687 361.136 113.075C359.857 105.463 360.13 97.6715 361.938 90.1678C362.131 89.3992 362.398 88.5437 363.156 88.2374C364.061 87.8969 364.993 88.58 365.676 89.2439C372.688 95.7412 379.322 102.636 385.543 109.894C386.108 110.555 386.705 111.331 386.594 112.176C386.447 112.8 386.118 113.366 385.647 113.801L381.409 118.549L389.39 115.183C391.325 118.691 393.279 122.234 394.399 126.081C395.067 128.384 394.895 131.672 392.526 132.177C394.383 131.548 395.963 133.599 396.867 135.363L408.856 158.698C409.258 159.484 409.666 160.396 409.321 161.201C409.044 161.888 408.26 162.253 407.564 162.552C402.804 164.589 400.734 166.331 396.377 163.546C391.69 160.565 387.663 155.054 382.577 152.748Z",
    fill: "url(#paint1_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.431 70.4235C405.374 77.3824 408.73 86.1493 411.563 94.8504C412.499 97.7109 413.394 100.673 413.113 103.67C412.832 106.667 411.099 109.707 408.235 110.634L414.609 111.45C414.446 120.613 414.306 129.935 416.589 138.827C417.438 142.138 418.621 145.382 418.972 148.779C419.375 152.846 418.569 156.942 416.653 160.553C415.552 162.621 413.903 164.628 411.58 165.058C408.018 165.712 405.079 162.394 403.063 159.383C398.317 152.274 392.705 144.114 390.011 135.939C387.799 129.232 388.058 120.953 388.332 113.948C388.63 106.269 389.751 98.6434 391.675 91.2031C392.23 89.0187 399.863 70.9305 399.431 70.4235Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.431 70.4235C405.374 77.3824 408.73 86.1493 411.563 94.8504C412.499 97.7109 413.394 100.673 413.113 103.67C412.832 106.667 411.099 109.707 408.235 110.634L414.609 111.45C414.446 120.613 414.306 129.935 416.589 138.827C417.438 142.138 418.621 145.382 418.972 148.779C419.375 152.846 418.569 156.942 416.653 160.553C415.552 162.621 413.903 164.628 411.58 165.058C408.018 165.712 405.079 162.394 403.063 159.383C398.317 152.274 392.705 144.114 390.011 135.939C387.799 129.232 388.058 120.953 388.332 113.948C388.63 106.269 389.751 98.6434 391.675 91.2031C392.23 89.0187 399.863 70.9305 399.431 70.4235Z",
    fill: "url(#paint2_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.357 124.285C420.299 115.73 407.662 109.436 416.022 105.098C413.626 116.708 430.097 128.472 420.674 135.679C421.841 137.885 419.87 140.345 418.347 142.305C416.408 144.81 414.988 147.677 414.171 150.738C413.354 153.799 413.155 156.993 413.588 160.131C413.153 157.082 412.15 155.596 412.511 152.258C412.828 149.371 412.595 146.786 412.489 143.769C412.242 137.062 413.566 130.389 416.357 124.285V124.285Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.357 124.285C420.299 115.73 407.662 109.436 416.022 105.098C413.626 116.708 430.097 128.472 420.674 135.679C421.841 137.885 419.87 140.345 418.347 142.305C416.408 144.81 414.988 147.677 414.171 150.738C413.354 153.799 413.155 156.993 413.588 160.131C413.153 157.082 412.15 155.596 412.511 152.258C412.828 149.371 412.595 146.786 412.489 143.769C412.242 137.062 413.566 130.389 416.357 124.285V124.285Z",
    fill: "url(#paint3_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.41 178.931L432.543 164.59L450.175 211.472C451.672 215.453 451.526 219.866 449.77 223.74C448.013 227.614 444.79 230.631 440.809 232.128L432.712 235.173C428.731 236.671 424.318 236.525 420.444 234.769C416.57 233.012 413.553 229.789 412.055 225.808L394.424 178.926L394.41 178.931Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.41 178.931L432.543 164.59L450.175 211.472C451.672 215.453 451.526 219.866 449.77 223.74C448.013 227.614 444.79 230.631 440.809 232.128L432.712 235.173C428.731 236.671 424.318 236.525 420.444 234.769C416.57 233.012 413.553 229.789 412.055 225.808L394.424 178.926L394.41 178.931Z",
    fill: "url(#paint4_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.868 131.842L115.557 211.688C99.3076 217.799 91.089 235.926 97.2001 252.175L125.387 327.124C131.498 343.373 149.625 351.592 165.874 345.48L378.184 265.634C394.434 259.523 402.653 241.396 396.541 225.147L368.355 150.199C362.244 133.949 344.117 125.731 327.868 131.842Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.868 131.842L115.557 211.688C99.3076 217.799 91.089 235.926 97.2001 252.175L125.387 327.124C131.498 343.373 149.625 351.592 165.874 345.48L378.184 265.634C394.434 259.523 402.653 241.396 396.541 225.147L368.355 150.199C362.244 133.949 344.117 125.731 327.868 131.842Z",
    fill: "url(#paint5_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.877 146.591L128.741 218.097C113.406 223.865 105.65 240.971 111.417 256.306L139.997 332.3C145.764 347.635 162.871 355.391 178.206 349.624L368.342 278.117C383.676 272.35 391.433 255.244 385.665 239.909L357.085 163.914C351.318 148.58 334.212 140.823 318.877 146.591Z",
    fill: "url(#paint6_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.226 221.82C229.826 224.582 232.948 225.909 235.701 226.538C240.503 227.629 245.448 227.939 250.348 227.455C251.412 227.35 252.556 227.219 253.493 227.745C255.449 228.846 255.019 231.889 253.663 233.678C252.307 235.468 250.294 236.836 249.537 238.952C248.447 241.991 250.238 245.842 248.228 248.37C247.628 249.039 246.916 249.597 246.122 250.018L237.583 255.205C257.51 249.046 277.114 241.891 296.324 233.768C293.004 229.515 289.689 225.263 286.38 221.01C281.787 215.118 276.807 208.938 269.755 206.476C266.059 205.189 262.102 205.033 258.204 205.091C252.612 205.17 240.544 204.418 235.866 207.912C233.399 209.767 228.558 218.735 229.226 221.82Z",
    fill: "url(#paint7_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.953 203.315C140.457 204.248 140.254 205.309 140.371 206.358C140.488 207.408 140.919 208.399 141.608 209.2C142.348 210.029 143.424 210.739 143.524 211.847C143.614 212.825 142.877 213.67 142.221 214.404C133.511 224.105 130.209 237.378 127.195 250.067C126.416 253.347 125.642 256.814 126.629 260.036C128.085 264.789 132.904 267.624 137.532 269.423C142.161 271.222 147.214 272.571 150.746 276.083C154.279 279.595 155.222 286.276 151.18 289.167C150.386 289.734 149.451 290.123 148.798 290.85C148.145 291.578 147.934 292.824 148.658 293.468C149.329 294.04 150.348 293.79 151.188 293.502C178.22 284.303 205.104 274.676 231.84 264.621C233.683 263.927 235.584 263.186 236.896 261.691C237.488 261.063 237.848 260.252 237.915 259.391C238.032 256.354 233.673 255.23 232.435 252.451C231.114 249.537 233.644 246.454 234.588 243.396C235.97 238.913 233.717 233.962 230.27 230.776C226.823 227.591 222.404 225.735 218.142 223.772C206.235 218.276 195.019 211.392 184.728 203.263C183.623 202.389 182.445 201.365 182.239 199.964C182.034 198.563 182.825 197.249 182.45 195.954C182.165 195.126 181.602 194.422 180.855 193.963C175.839 190.42 169.011 193.137 163.311 195.421C159.015 197.137 154.61 198.565 150.124 199.695C147.15 200.444 142.598 200.314 140.953 203.315Z",
    fill: "url(#paint8_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.224 157.623C268.693 155.959 272.247 154.478 275.871 153.185C279.383 151.918 289.47 146.149 294.012 144.574C297.33 143.428 291.896 157.086 294.702 159.222C299.203 162.648 305.381 162.515 310.896 163.84C317.342 165.401 323.095 169.041 327.267 174.197C330.535 178.258 332.685 183.093 334.729 187.888C336.138 191.192 337.545 194.662 337.279 198.243C336.997 202.033 334.88 205.999 336.54 209.417C337.178 210.73 338.295 211.734 339.11 212.948C339.925 214.162 340.388 215.82 339.583 217.054C339.208 217.571 338.728 218.003 338.175 218.322C327.54 225.438 314.703 228.221 302.422 231.817C290.489 235.309 278.827 239.668 267.168 244.004C268.03 238.088 268.426 232.113 268.352 226.136C268.321 224.632 268.27 223.071 267.656 221.696C266.805 219.815 265.036 218.542 263.395 217.285C257.512 212.789 252.249 207.154 249.578 200.25C246.724 192.874 247.393 184.66 252.148 178.267C254.14 175.59 255.708 172.826 257.512 170.049C258.524 168.469 271.43 168.943 272.291 167.259C273.152 165.575 263.92 158.242 265.224 157.623Z",
    fill: "url(#paint9_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.763 231.783C223.783 232.108 223.788 232.433 223.779 232.779C223.642 240.289 217.061 253.286 217.061 253.286L220.177 262.625C212.362 272.187 163.833 285.083 163.833 285.083C163.833 285.083 158.793 278.599 158.197 278.539C157.602 278.48 144.479 272.802 139.174 269.245C138.49 268.824 137.863 268.319 137.307 267.741C134.631 264.656 138.072 254.329 138.867 234.444C139.661 214.558 156.272 211.047 156.272 211.047C156.272 211.047 185.953 199.231 194.692 201.112C203.431 202.992 223.263 224.502 223.763 231.783Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M223.246 236.786C222.238 241.497 219.996 246.924 218.501 250.238C217.59 252.268 217.479 254.566 218.19 256.673V256.673C218.842 258.612 218.798 260.717 218.067 262.627C217.335 264.537 215.96 266.133 214.18 267.139C202.647 273.619 180.042 280.514 169.501 283.509C167.864 283.973 166.128 283.955 164.501 283.458C162.875 282.96 161.426 282.004 160.328 280.704C159.346 279.516 158.45 278.557 158.222 278.535C157.837 278.493 150.46 275.35 144.507 272.278C142.906 271.455 141.594 270.163 140.747 268.575C139.9 266.986 139.558 265.177 139.766 263.389C140.397 258.076 141.314 250.989 141.675 241.912C142.377 223.844 156.201 219.314 158.678 218.624C158.984 218.541 159.273 218.443 159.569 218.332C163.509 216.791 189.413 206.851 197.482 208.587C203.616 209.905 215.214 220.884 221.762 229.837C222.483 230.826 222.988 231.956 223.244 233.154C223.499 234.351 223.5 235.589 223.246 236.786V236.786Z",
    fill: "url(#paint10_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.276 195.05C329.69 191.603 312.307 172.075 304.777 170.677C299.516 169.7 281.546 167.607 271.187 166.432C266.268 165.873 261.312 167.109 257.231 169.914C249.826 174.996 237.808 183.59 231.059 190.289C220.849 200.458 225.861 205.442 227.249 208.39C228.636 211.338 260.149 217.837 260.149 217.837L268.081 230.114L270.554 229.114L294.788 219.347L300.761 224.281L302.093 225.387C302.093 225.387 304.804 223.457 308.564 220.811L310.824 219.217C317.685 214.382 326.597 208.166 329.744 206.211C335.132 202.884 332.861 198.496 331.276 195.05ZM264.365 204.9L251.955 199.891L247.986 197.711L256.414 192.399C257.308 191.929 258.211 191.483 259.15 191.033L264.365 204.9ZM304.625 195.6C304.619 194.618 304.514 193.638 304.312 192.677L303.995 191.163L303.081 186.827L314.307 198.609L313.456 199.192L306.576 203.921C305.761 201.189 305.11 198.41 304.625 195.6V195.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M323.238 194.207C323.902 196.372 323.038 198.774 321.623 200.522C320.208 202.269 318.232 203.505 316.304 204.701C315.154 205.417 313.95 206.159 312.605 206.328C311.261 206.496 309.717 205.936 309.182 204.686C311.126 203.416 312.895 201.896 314.443 200.165C314.994 199.663 315.345 198.98 315.432 198.24C315.44 197.562 314.285 198.891 313.505 199.168L314.357 198.585L303.131 186.802L304.044 191.139C304.213 192.682 304.424 194.155 304.675 195.576C305.166 198.388 305.823 201.167 306.643 203.901C307.783 207.756 309.191 211.601 310.852 216.117C311.196 216.862 311.298 217.696 311.144 218.502C311.074 218.737 310.966 218.959 310.823 219.158C310.225 219.881 309.445 220.431 308.563 220.752L308.479 220.784L300.76 224.222L288.505 229.693C285.378 231.089 282.131 232.519 278.703 232.475C276.609 232.423 274.565 231.83 272.768 230.752C270.972 229.675 269.486 228.15 268.456 226.327C265.895 221.667 266.712 215.995 266.803 210.67C266.903 203.364 265.439 196.121 262.508 189.427C261.376 189.917 260.254 190.428 259.144 190.96C258.238 191.397 257.311 191.853 256.408 192.327C253.393 193.879 250.461 195.59 247.626 197.45L247.971 197.641L251.939 199.822L261.792 205.219C253.534 211.736 240.063 210.088 233.597 201.778C233.029 201.113 232.61 200.334 232.368 199.493C231.791 196.963 233.989 194.734 235.977 193.071L253.436 178.473C259.458 173.456 265.262 169.528 273.269 169.986C280.206 170.381 300.067 173.728 306.354 177.548C309.831 179.673 312.854 186.787 316.801 188.611C319.479 189.907 322.38 191.429 323.238 194.207Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.804 223.118L408.19 237.44C409.452 240.794 410.042 244.364 409.925 247.945C409.809 251.527 408.987 255.051 407.509 258.315C406.03 261.58 403.923 264.521 401.308 266.971C398.692 269.421 395.62 271.332 392.266 272.595L156.623 361.216C149.849 363.763 142.342 363.516 135.751 360.527C129.161 357.539 124.028 352.056 121.48 345.282V345.282L116.089 330.947C113.541 324.18 113.785 316.678 116.767 310.092C119.749 303.505 125.226 298.372 131.991 295.822L367.668 207.188C374.435 204.64 381.936 204.884 388.523 207.866C395.11 210.848 400.243 216.324 402.793 223.09L402.804 223.118Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.804 223.118L408.19 237.44C409.452 240.794 410.042 244.364 409.925 247.945C409.809 251.527 408.987 255.051 407.509 258.315C406.03 261.58 403.923 264.521 401.308 266.971C398.692 269.421 395.62 271.332 392.266 272.595L156.623 361.216C149.849 363.763 142.342 363.516 135.751 360.527C129.161 357.539 124.028 352.056 121.48 345.282V345.282L116.089 330.947C113.541 324.18 113.785 316.678 116.767 310.092C119.749 303.505 125.226 298.372 131.991 295.822L367.668 207.188C374.435 204.64 381.936 204.884 388.523 207.866C395.11 210.848 400.243 216.324 402.793 223.09L402.804 223.118Z",
    fill: "url(#paint11_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.08 210.476C392.048 214.824 389.962 218.851 387.007 222.204C384.052 225.556 380.318 228.13 376.134 229.7L140.491 318.321C136.308 319.897 131.803 320.421 127.371 319.847C122.938 319.273 118.715 317.619 115.072 315.03C116.105 310.682 118.192 306.654 121.148 303.302C124.103 299.949 127.838 297.375 132.022 295.805L367.666 207.183C371.847 205.605 376.353 205.08 380.785 205.654C385.217 206.229 389.439 207.885 393.08 210.476V210.476Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.08 210.476C392.048 214.824 389.962 218.851 387.007 222.204C384.052 225.556 380.318 228.13 376.134 229.7L140.491 318.321C136.308 319.897 131.803 320.421 127.371 319.847C122.938 319.273 118.715 317.619 115.072 315.03C116.105 310.682 118.192 306.654 121.148 303.302C124.103 299.949 127.838 297.375 132.022 295.805L367.666 207.183C371.847 205.605 376.353 205.08 380.785 205.654C385.217 206.229 389.439 207.885 393.08 210.476V210.476Z",
    fill: "url(#paint12_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.977 273.236C281.903 283.424 284.075 294.098 290.73 302.042C291.716 303.24 293.204 304.448 294.655 303.934C295.719 303.534 296.286 302.378 296.592 301.283C298.487 294.547 295.19 287.589 292.541 281.116C288.113 270.224 285.568 257.276 291.465 247.102C293.759 243.149 297.967 239.66 302.468 240.436C307.404 241.289 310.06 246.571 311.953 251.208C315.006 258.67 318.058 266.136 321.11 273.605C323.621 279.756 326.419 286.296 332.05 289.881C335.635 292.195 341.124 292.653 343.601 289.173C345.292 286.791 344.899 283.555 344.293 280.704C340.974 265.263 333.52 251.015 322.729 239.483C318.464 234.934 313.366 230.689 307.216 229.655C303.88 229.1 300.442 229.525 297.159 230.337C288.448 232.486 280.554 237.13 274.443 243.699C270.205 248.276 274.577 250.106 276.377 254.152C278.768 259.555 278.878 267.422 279.977 273.236Z",
    fill: "url(#paint13_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.558 341.664C203.837 340.241 203.275 338.804 202.737 337.459C198.376 326.497 195.01 315.164 192.68 303.599C191.812 299.283 191.092 294.777 192.212 290.522C193.332 286.267 196.769 282.335 201.161 281.941C202.366 281.842 203.691 282.061 204.514 282.94C204.946 283.466 205.277 284.068 205.487 284.716C210.806 298.422 215.884 312.219 220.721 326.106C221.654 328.786 222.726 331.665 225.119 333.186C229.125 335.738 234.397 333.139 238.04 330.099C239.319 329.029 240.593 327.832 241.145 326.254C241.808 324.344 241.299 322.249 240.77 320.301C236.216 303.539 230.544 287.1 223.791 271.096C223.298 269.927 222.77 268.723 221.818 267.887C219.838 266.152 216.836 266.585 214.259 267.121C203.862 269.29 193.326 271.502 183.819 276.234C181.61 277.338 179.396 278.626 177.969 280.613C176.604 282.492 176.034 284.821 175.554 287.09C173.325 297.679 172.3 308.736 174.607 319.311C176.474 327.878 180.711 336.254 187.358 342.097C190.721 345.116 202.12 348.86 203.558 341.664Z",
    fill: "url(#paint14_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79 284.627L102.514 287.364C96.5738 289.598 93.5691 296.225 95.8033 302.165L98.5396 309.441C100.774 315.382 107.401 318.387 113.341 316.152L120.617 313.416C126.558 311.182 129.562 304.555 127.328 298.614L124.592 291.338C122.358 285.398 115.731 282.393 109.79 284.627Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.247 181.409L376.972 184.145C371.031 186.379 368.026 193.006 370.26 198.947L372.997 206.223C375.231 212.163 381.858 215.168 387.798 212.934L395.074 210.198C401.015 207.963 404.02 201.336 401.785 195.396L399.049 188.12C396.815 182.179 390.188 179.175 384.247 181.409Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79 284.627L102.514 287.364C96.5738 289.598 93.5691 296.225 95.8033 302.165L98.5396 309.441C100.774 315.382 107.401 318.387 113.341 316.152L120.617 313.416C126.558 311.182 129.562 304.555 127.328 298.614L124.592 291.338C122.358 285.398 115.731 282.393 109.79 284.627Z",
    fill: "url(#paint15_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.247 181.409L376.972 184.145C371.031 186.379 368.026 193.006 370.26 198.947L372.997 206.223C375.231 212.163 381.858 215.168 387.798 212.934L395.074 210.198C401.015 207.963 404.02 201.336 401.785 195.396L399.049 188.12C396.815 182.179 390.188 179.175 384.247 181.409Z",
    fill: "url(#paint16_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.721 200.985C150.721 200.985 158.583 221.278 169.983 218.715C181.383 216.152 181.267 202.332 179.125 192.707C176.983 183.082 160.154 172.534 151.671 184.388C146.298 191.87 150.721 200.985 150.721 200.985Z",
    fill: "url(#paint17_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.496 208.417C152.016 204.172 149.412 199.539 149.187 194.628C149.052 191.691 149.557 188.337 151.979 186.66C155.217 184.42 159.565 186.485 163.499 186.611C167.434 186.738 171.679 184.826 175.194 186.641C176.801 187.467 177.953 188.95 179.046 190.392C178.541 186.425 176.648 182.765 173.704 180.059C174.611 180.446 175.634 180.463 176.554 180.106C175.562 177.325 173.134 175.283 170.542 173.886C164.859 170.834 157.588 170.436 152.043 173.732C144.904 177.97 145.574 184.352 144.902 191.276C144.22 198.333 147.837 203.141 154.496 208.417Z",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.534 218.263C164.534 218.263 169.142 229.092 174.6 226.022C180.058 222.952 177.687 213.317 177.687 213.317C176.216 215.334 174.187 216.878 171.85 217.757C169.513 218.636 166.97 218.812 164.534 218.263V218.263Z",
    fill: "url(#paint18_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.612 152.683C258.612 152.683 266.469 172.978 277.873 170.413C289.277 167.848 289.152 154.032 287.015 144.405C284.878 134.779 268.04 124.234 259.556 136.088C254.188 143.568 258.612 152.683 258.612 152.683Z",
    fill: "url(#paint19_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.424 169.961C272.424 169.961 277.032 180.79 282.49 177.72C287.948 174.65 285.573 165.016 285.573 165.016C284.104 167.036 282.076 168.581 279.739 169.459C277.402 170.338 274.859 170.513 272.424 169.961Z",
    fill: "url(#paint20_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25 265.98C162.25 265.98 155.104 275.141 158.212 278.523C161.321 281.905 167.153 271.386 167.085 270.067C167.018 268.749 167.896 262.298 162.25 265.98Z",
    fill: "url(#paint21_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.845 272.469C172.845 272.469 168.497 275.346 165.263 273.992C163.051 273.137 160.717 272.635 158.349 272.507L162.623 263.939C162.623 263.939 167.646 258.162 170.926 256.575C174.206 254.988 176.358 256.139 176.358 256.139C176.358 256.139 174.698 260.881 172.593 261.008C170.489 261.136 169.04 264.374 169.04 264.374C169.04 264.374 169.903 269.516 171.68 269.271C173.456 269.026 177.585 269.781 177.585 269.781C177.585 269.781 180.408 270.952 172.845 272.469Z",
    fill: "url(#paint22_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.571 246.582C205.571 246.582 216.984 248.768 216.868 253.358C216.752 257.948 205.454 253.903 204.629 252.848C203.803 251.792 198.909 247.534 205.571 246.582Z",
    fill: "url(#paint23_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.882 258.459C201.882 258.459 207.044 257.76 208.589 254.608C209.694 252.505 211.121 250.588 212.819 248.927L203.958 245.298C203.958 245.298 196.372 244.264 192.86 245.231C189.347 246.199 188.487 248.482 188.487 248.482C188.487 248.482 192.86 250.955 194.527 249.664C196.194 248.373 199.417 249.854 199.417 249.854C199.417 249.854 202.157 254.291 200.659 255.277C199.161 256.264 196.554 259.552 196.554 259.552C196.554 259.552 195.172 262.299 201.882 258.459Z",
    fill: "url(#paint24_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.701 259.407C174.701 259.407 176.897 259.909 180.746 257.942C184.596 255.975 189.463 253.057 189.829 252.036C190.217 251.183 190.738 250.398 191.374 249.71C191.374 249.71 195.555 246.59 199.453 249.836C203.351 253.082 199.644 256.152 199.644 256.152C199.644 256.152 198.888 260.377 193.675 262.22C188.462 264.063 177.571 269.802 177.571 269.802C177.571 269.802 168.349 269.485 168.332 266.905C168.315 264.325 168.65 260.874 174.701 259.407Z",
    fill: "url(#paint25_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.681 264.042C173.681 264.042 170.032 267.824 172.657 269.862C175.282 271.9 179.803 268.647 179.803 268.647C179.803 268.647 190.961 263.005 193.675 262.22C196.389 261.435 201.899 256.766 201.105 253.729C200.31 250.691 197.783 249.409 192.897 253.715C188.01 258.021 185.273 260.866 180.799 261.799C178.35 262.276 175.962 263.029 173.681 264.042Z",
    fill: "url(#paint26_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.612 263.953L151.999 255.667C151.999 255.667 155.564 240.003 155.402 237.151C155.24 234.299 170.925 256.586 170.925 256.586C170.925 256.586 162.969 261.913 162.612 263.953Z",
    fill: "url(#paint27_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.571 246.582L207.299 231.245L197.065 221.274L200.947 244.98C200.947 244.98 203.854 244.01 205.571 246.582Z",
    fill: "url(#paint28_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.425 283.331C154.425 283.331 156.087 274.937 172.836 272.488C189.585 270.039 201.935 266.187 204.416 262.491C206.897 258.795 207.705 255.262 216.863 253.36C226.714 251.32 227.921 256.58 233.164 263.657C238.98 271.504 245.973 314.302 245.973 314.302L232.162 319.496C232.162 319.496 214.268 270.962 206.508 272.268C201.547 273.101 192.2 276.509 187.121 278.323C184.127 279.389 181.418 285.169 181.397 288.346C181.344 297.63 182.504 317.187 192.117 331.172L179.089 337.437C179.089 337.437 154.394 314.87 154.425 283.331Z",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.089 337.437L184.315 345.822C184.315 345.822 190.249 345.486 191.695 341.242C193.14 336.998 190.043 332.166 190.043 332.166L179.089 337.437Z",
    fill: "url(#paint29_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.751 348.936L181.538 341.357C181.538 341.357 185.081 346.621 191.904 337.056L191.165 334.422C191.165 334.422 191.451 333.859 193.049 335.26C194.647 336.662 197.678 342.499 197.678 342.499C197.678 342.499 198.599 346.672 197.174 348.605C196.192 349.939 191.938 356.668 189.406 360.699C188.694 361.834 187.717 362.78 186.559 363.456C185.401 364.131 184.097 364.515 182.758 364.575C180.599 364.659 180.529 365.483 179.798 363.627C178.28 359.716 177.589 353.267 179.751 348.936Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.918 315.075L245.064 322.065C245.295 323.399 244.988 324.771 244.208 325.878C243.429 326.986 242.242 327.738 240.907 327.971L240.751 327.997C239.503 328.178 238.231 327.939 237.133 327.318C233.262 325.068 232.367 319.413 232.367 319.413L243.918 315.075Z",
    fill: "url(#paint30_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.841 320.719C244.841 320.719 245.645 327.014 234.21 324.316L233.035 321.845C233.035 321.845 232.447 321.605 232.166 323.719C231.884 325.833 233.45 332.259 233.45 332.259C233.45 332.259 235.506 336.004 237.844 336.496C239.764 336.92 259.187 345.566 261.959 336.278C262.285 335.279 262.269 334.2 261.913 333.211C260.488 329.249 244.841 320.719 244.841 320.719Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.751 348.936L181.538 341.357C181.538 341.357 185.081 346.621 191.904 337.056L191.165 334.422C191.165 334.422 191.451 333.859 193.049 335.26C194.647 336.662 197.678 342.499 197.678 342.499C197.678 342.499 198.599 346.672 197.174 348.605C196.192 349.939 191.938 356.668 189.406 360.699C188.694 361.834 187.717 362.78 186.559 363.456C185.401 364.131 184.097 364.515 182.758 364.575C180.599 364.659 180.529 365.483 179.798 363.627C178.28 359.716 177.589 353.267 179.751 348.936Z",
    fill: "url(#paint31_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.841 320.719C244.841 320.719 245.645 327.014 234.21 324.316L233.035 321.845C233.035 321.845 232.447 321.605 232.166 323.719C231.884 325.833 233.45 332.259 233.45 332.259C233.45 332.259 235.506 336.004 237.844 336.496C239.764 336.92 259.187 345.566 261.959 336.278C262.285 335.279 262.269 334.2 261.913 333.211C260.488 329.249 244.841 320.719 244.841 320.719Z",
    fill: "url(#paint32_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.975 278.171L351.063 284.781C351.283 286.042 350.993 287.338 350.257 288.385C349.521 289.432 348.399 290.144 347.139 290.364L346.987 290.389C345.809 290.557 344.608 290.331 343.571 289.746C339.907 287.622 339.063 282.275 339.063 282.275L349.975 278.171Z",
    fill: "url(#paint33_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847 283.508C350.847 283.508 351.605 289.455 340.8 286.906L339.687 284.573C339.687 284.573 339.131 284.348 338.869 286.342C338.607 288.336 340.071 294.393 340.071 294.393C340.071 294.393 342.017 297.945 344.232 298.424C346.043 298.813 364.401 306.993 367.018 298.218C367.337 297.275 367.329 296.252 366.996 295.313C365.631 291.57 350.847 283.508 350.847 283.508Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.357 294.008L279.904 299.694C280.569 300.785 281.64 301.568 282.882 301.87C284.125 302.172 285.436 301.969 286.528 301.304L286.658 301.223C287.656 300.574 288.411 299.612 288.805 298.488C290.161 294.476 287.273 289.903 287.273 289.903L276.357 294.008Z",
    fill: "url(#paint34_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.242 298.588C279.242 298.588 282.59 303.561 289.036 294.519L288.336 292.03C288.336 292.03 288.606 291.495 290.117 292.822C291.628 294.149 294.513 299.656 294.513 299.656C294.513 299.656 295.389 303.61 294.042 305.423C292.931 306.912 284.514 325.166 276.764 320.29C275.904 319.789 275.236 319.015 274.866 318.091C273.431 314.39 279.242 298.588 279.242 298.588Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.847 283.508C350.847 283.508 351.605 289.455 340.8 286.906L339.687 284.573C339.687 284.573 339.131 284.348 338.869 286.342C338.607 288.336 340.071 294.393 340.071 294.393C340.071 294.393 342.017 297.945 344.232 298.424C346.043 298.813 364.401 306.993 367.018 298.218C367.337 297.275 367.329 296.252 366.996 295.313C365.631 291.57 350.847 283.508 350.847 283.508Z",
    fill: "url(#paint35_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.242 298.588C279.242 298.588 282.59 303.561 289.036 294.519L288.336 292.03C288.336 292.03 288.606 291.495 290.117 292.822C291.628 294.149 294.513 299.656 294.513 299.656C294.513 299.656 295.389 303.61 294.042 305.423C292.931 306.912 284.514 325.166 276.764 320.29C275.904 319.789 275.236 319.015 274.866 318.091C273.431 314.39 279.242 298.588 279.242 298.588Z",
    fill: "url(#paint36_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.317 152.8L387.953 169.108L392.824 182.06L436.188 165.752L431.317 152.8Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.457 152.747L388.094 169.055L392.965 182.007L436.328 165.699L431.457 152.747Z",
    fill: "url(#paint37_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.309 227.912C273.309 227.912 252.355 229.217 254.38 244.669C256.406 260.121 276.098 296.167 276.098 296.167L286.888 292.109L287.817 288.316C287.817 288.316 278.125 255.925 278.03 253.75C277.935 251.574 281.166 239.72 287.1 237.488C293.034 235.256 305.949 226.116 317.316 241.079C328.684 256.043 338.813 283.632 338.813 283.632L350.863 277.687C350.863 277.687 340.767 240.961 334.743 230.552C328.719 220.144 323.22 212.611 318.19 211.852C313.161 211.094 273.309 227.912 273.309 227.912Z",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76 223.657C286.76 223.657 284.879 226.244 282.872 228.867C280.866 231.49 278.719 234.113 278.189 234.253C277.116 234.534 275.741 234.992 272.655 231.044C269.57 227.096 266.303 227.366 266.042 226.956C265.78 226.546 257.817 223.667 257.244 222.897C256.84 222.364 255.276 220.81 255.943 218.257C256.393 216.834 257.182 215.542 258.244 214.494C261.564 211.029 265.067 207.746 268.74 204.657C269.171 204.781 269.569 204.999 269.905 205.296C270.241 205.593 270.506 205.961 270.681 206.374C271.374 207.832 270.398 212.585 270.629 214.152C270.86 215.72 275.111 218.823 275.111 218.823C275.111 218.823 277.478 219.094 278.343 218.732C279.208 218.369 287.374 212.562 288.38 212.403C289.386 212.244 295.338 213.079 286.76 223.657Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76 223.657C286.76 223.657 284.879 226.244 282.872 228.867C280.866 231.49 278.719 234.113 278.189 234.253C277.116 234.534 275.741 234.992 272.655 231.044C269.57 227.096 266.303 227.366 266.042 226.956C265.78 226.546 257.817 223.667 257.244 222.897C256.84 222.364 255.276 220.81 255.943 218.257C256.393 216.834 257.182 215.542 258.244 214.494C261.564 211.029 265.067 207.746 268.74 204.657C269.171 204.781 269.569 204.999 269.905 205.296C270.241 205.593 270.506 205.961 270.681 206.374C271.374 207.832 270.398 212.585 270.629 214.152C270.86 215.72 275.111 218.823 275.111 218.823C275.111 218.823 277.478 219.094 278.343 218.732C279.208 218.369 287.374 212.562 288.38 212.403C289.386 212.244 295.338 213.079 286.76 223.657Z",
    fill: "url(#paint38_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.869 228.858C280.862 231.465 278.716 234.103 278.185 234.244C277.113 234.524 275.738 234.983 272.652 231.035C269.566 227.087 266.279 227.344 266.038 226.947C265.798 226.55 257.814 223.657 257.24 222.888C256.836 222.354 255.272 220.801 255.94 218.247C256.176 218.297 256.404 218.383 256.614 218.502C256.614 218.502 258.795 221.939 261.758 222.115C264.721 222.291 273.319 227.941 273.319 227.941C273.319 227.941 274.518 231.741 276.753 231.661C278.988 231.581 282.869 228.858 282.869 228.858Z",
    fill: "url(#paint39_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.956 221.963C297.956 221.963 291.913 229.954 288.17 230.382C285.851 230.65 283.516 230.755 281.183 230.696L286.762 223.661C286.762 223.661 285.121 220.723 281.885 220.987C278.648 221.251 280.121 217.72 282.875 217.043C285.63 216.366 288.065 215.552 288.065 215.552L290.313 215.151L297.956 221.963Z",
    fill: "url(#paint40_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.251 220.736C253.448 221.801 253.929 222.793 254.643 223.608C255.358 224.422 256.279 225.028 257.309 225.362C257.684 225.495 258.088 225.528 258.48 225.457C258.668 225.412 258.841 225.316 258.978 225.179C259.116 225.042 259.213 224.871 259.259 224.682C259.38 223.963 258.584 223.485 257.987 223.078C256.009 221.734 256.412 217.368 257.414 215.192C257.556 214.94 257.656 214.668 257.71 214.385C257.719 214.037 257.59 213.7 257.35 213.448C257.111 213.195 256.781 213.048 256.433 213.039L256.363 213.038C255.619 213.11 254.13 215.571 253.863 216.158C253.191 217.584 252.977 219.183 253.251 220.736V220.736Z",
    fill: "url(#paint41_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.326 148.532C250.858 146.861 251.045 144.938 249.991 143.557C249.429 142.804 248.578 142.321 247.955 141.645C246.204 139.696 246.608 136.642 247.548 134.2C249.556 129.017 253.415 124.813 257.028 120.595C258.092 119.354 259.17 118.076 260.586 117.243C262.003 116.411 263.831 116.119 265.256 116.917C265.737 117.275 266.266 117.565 266.827 117.777C267.822 118.003 268.76 117.307 269.716 116.916C270.533 116.59 271.422 116.484 272.293 116.611C273.164 116.737 273.986 117.091 274.677 117.636C275.952 118.661 276.769 120.351 278.35 120.795C279.333 121.074 280.417 120.783 281.393 121.086C282.13 121.38 282.789 121.839 283.322 122.427C284.433 123.484 285.543 124.537 286.652 125.587C289.531 128.317 292.61 131.464 292.79 135.428C292.793 136.758 292.621 138.083 292.279 139.368C291.897 141.133 291.516 142.9 291.136 144.671C290.691 146.734 289.816 149.22 287.728 149.519C287.016 147.398 286.306 145.277 285.597 143.156C285.398 142.626 285.156 141.983 284.59 141.901C284.126 141.835 283.72 142.18 283.3 142.386C281.258 143.251 279.638 140.551 277.688 139.496C277.091 139.18 276.426 139.016 275.75 139.017C275.075 139.018 274.41 139.184 273.814 139.502C272.776 140.074 271.949 141.108 270.78 141.301C269.432 141.519 268.198 140.543 266.858 140.297C263.64 139.714 261.335 143.226 259.975 146.2L258.615 149.191C258.346 149.785 258.072 150.466 258.3 151.071C259.896 155.402 252.186 151.587 251.326 148.532Z",
    fill: "#333335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.986 197.711L251.955 199.892L247.427 198.06L247.986 197.711Z",
    fill: "url(#paint42_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.041 190.742L259.15 191.033C258.244 191.47 257.317 191.926 256.414 192.399L259.041 190.742Z",
    fill: "url(#paint43_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M304.625 195.601C305.116 198.412 305.773 201.192 306.594 203.925L290.313 215.151L299.859 206.463C301.37 205.087 302.575 203.409 303.396 201.538C304.217 199.667 304.635 197.644 304.625 195.601V195.601Z",
    fill: "#AD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.146 219.252C260.294 219.374 260.477 219.448 260.669 219.462C260.816 219.439 260.953 219.377 261.066 219.281C261.18 219.186 261.265 219.061 261.312 218.92C261.886 217.714 261.279 216.314 261.102 214.989C260.906 213.57 261.215 212.127 261.973 210.913C262.815 209.563 264.202 208.511 264.597 206.97C264.712 206.424 264.761 205.867 264.744 205.309C264.746 205.131 264.711 204.909 264.534 204.852C264.472 204.843 264.407 204.847 264.346 204.864C261.62 205.531 259.061 206.755 256.832 208.461C256.001 209.1 255.18 209.864 254.916 210.884C254.652 211.905 255.045 213.079 255.6 214.027C255.889 214.529 256.331 214.926 256.861 215.159C257.08 215.262 257.275 215.409 257.435 215.59C257.595 215.771 257.717 215.982 257.792 216.212C258.312 217.405 259.121 218.45 260.146 219.252V219.252Z",
    fill: "url(#paint44_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.662 216.388C262.522 216.473 262.415 216.602 262.359 216.756C262.302 216.91 262.3 217.078 262.353 217.233C262.415 217.385 262.517 217.517 262.649 217.616C262.78 217.715 262.936 217.776 263.099 217.793C263.262 217.806 263.426 217.786 263.582 217.735C263.737 217.684 263.881 217.602 264.004 217.495C264.076 217.442 264.133 217.371 264.168 217.289C264.213 217.151 264.204 217.002 264.144 216.87C264.089 216.717 264.001 216.579 263.885 216.466C263.769 216.353 263.629 216.267 263.475 216.216C263.319 216.173 263.153 216.181 263.001 216.238C262.85 216.295 262.72 216.398 262.631 216.534",
    fill: "url(#paint45_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.823 212.788C262.683 212.873 262.576 213.003 262.52 213.156C262.464 213.31 262.462 213.478 262.514 213.633C262.576 213.785 262.679 213.918 262.81 214.016C262.941 214.115 263.097 214.176 263.26 214.193C263.59 214.217 263.915 214.11 264.166 213.895C264.237 213.84 264.294 213.769 264.334 213.687C264.379 213.55 264.369 213.4 264.305 213.27C264.251 213.117 264.163 212.979 264.047 212.866C263.931 212.752 263.791 212.667 263.637 212.616C263.48 212.573 263.315 212.581 263.163 212.638C263.011 212.695 262.881 212.799 262.792 212.934",
    fill: "url(#paint46_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.899 212.494C265.758 212.578 265.651 212.708 265.595 212.862C265.539 213.015 265.537 213.184 265.59 213.338C265.652 213.491 265.754 213.623 265.885 213.722C266.017 213.82 266.172 213.881 266.336 213.898C266.665 213.922 266.99 213.815 267.241 213.601C267.313 213.548 267.369 213.477 267.405 213.395C267.449 213.257 267.441 213.107 267.381 212.975C267.326 212.823 267.238 212.685 267.122 212.572C267.006 212.458 266.866 212.373 266.712 212.322C266.556 212.279 266.39 212.286 266.238 212.343C266.086 212.401 265.957 212.504 265.868 212.64",
    fill: "url(#paint47_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.941 215.155C265.798 215.237 265.689 215.366 265.632 215.521C265.575 215.676 265.575 215.845 265.632 216C265.693 216.152 265.795 216.286 265.927 216.384C266.058 216.483 266.214 216.544 266.378 216.56C266.541 216.573 266.705 216.553 266.861 216.502C267.016 216.451 267.16 216.369 267.283 216.262C267.377 216.191 267.443 216.089 267.47 215.975C267.496 215.86 267.481 215.74 267.428 215.635C267.372 215.483 267.282 215.345 267.165 215.232C267.049 215.12 266.908 215.034 266.754 214.983C266.599 214.938 266.433 214.944 266.282 215.001C266.13 215.058 266.002 215.163 265.915 215.299",
    fill: "url(#paint48_linear_60_334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.44 226.053C258.101 235.441 258.324 258.103 258.658 270.01C258.78 274.606 259.513 279.674 260.327 284.856C261.631 293.136 263.145 301.702 262.803 309.038C261.959 327.025 254.065 336.291 256.276 354.328L253.091 355.526C249.336 348.213 243.993 341.833 237.453 336.852C225.87 327.822 208.007 319.606 197.737 308.417C196.779 307.376 195.876 306.286 195.031 305.151C187.529 294.998 175.869 261.757 186.949 257.59C178.561 265.029 187.023 283.8 191.051 295.264C192.748 300.017 195.47 304.339 199.024 307.922C204.022 313.126 210.354 317.192 216.801 322.017C227.596 330.107 239.906 333.793 253.295 349.078L259.525 319.229C260.385 315.109 261.238 310.97 261.353 306.761C261.504 300.044 260.179 292.494 259.069 285.34C258.653 282.696 258.269 280.11 257.997 277.636C256.281 261.983 256.839 249.158 261.615 232.241C262.32 229.63 263.799 223.896 265.44 226.053Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_334",
    x1: 249.288,
    y1: 196.177,
    x2: 291.816,
    y2: 318.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_334",
    x1: 397.41,
    y1: 121.002,
    x2: 375.559,
    y2: 129.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60_334",
    x1: 423.093,
    y1: 118.02,
    x2: 393.485,
    y2: 117.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60_334",
    x1: 427.821,
    y1: 142.865,
    x2: 409.987,
    y2: 128.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_60_334",
    x1: 406.048,
    y1: 209.878,
    x2: 444.182,
    y2: 195.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_60_334",
    x1: 284.659,
    y1: 335.644,
    x2: 226.252,
    y2: 185.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_60_334",
    x1: 283.649,
    y1: 355.525,
    x2: 223.164,
    y2: 170.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_60_334",
    x1: 289.086,
    y1: 109.663,
    x2: 255.638,
    y2: 258.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_60_334",
    x1: 114.046,
    y1: 63.2298,
    x2: 188.563,
    y2: 270.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_60_334",
    x1: 316.59,
    y1: 338.183,
    x2: 281.062,
    y2: 125.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_60_334",
    x1: 138.035,
    y1: 261.577,
    x2: 222.14,
    y2: 229.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8EEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_60_334",
    x1: 229.975,
    y1: 198.669,
    x2: 275.211,
    y2: 318.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_60_334",
    x1: 243.533,
    y1: 234.72,
    x2: 262.262,
    y2: 284.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_60_334",
    x1: 260.869,
    y1: 140.29,
    x2: 325.794,
    y2: 315.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_60_334",
    x1: 161.598,
    y1: 192.917,
    x2: 214.945,
    y2: 338.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_60_334",
    x1: 80.2236,
    y1: 225.458,
    x2: 127.175,
    y2: 337.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_60_334",
    x1: 368.198,
    y1: 148.614,
    x2: 395.916,
    y2: 224.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_60_334",
    x1: 160.771,
    y1: 184.965,
    x2: 170.446,
    y2: 212.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_60_334",
    x1: 166.444,
    y1: 223.344,
    x2: 179.598,
    y2: 218.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_60_334",
    x1: 267.975,
    y1: 134.469,
    x2: 278.157,
    y2: 164.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_60_334",
    x1: 274.334,
    y1: 175.042,
    x2: 287.483,
    y2: 170.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_60_334",
    x1: 156.389,
    y1: 274.245,
    x2: 168.14,
    y2: 269.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_60_334",
    x1: 157.458,
    y1: 270.138,
    x2: 178.628,
    y2: 262.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_60_334",
    x1: 211.788,
    y1: 244.179,
    x2: 205.915,
    y2: 261.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_60_334",
    x1: 190.757,
    y1: 254.52,
    x2: 211.928,
    y2: 246.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_60_334",
    x1: 180.981,
    y1: 254.009,
    x2: 194.769,
    y2: 274.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_60_334",
    x1: 184.11,
    y1: 255.595,
    x2: 190.424,
    y2: 270.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_60_334",
    x1: 181.46,
    y1: 313.017,
    x2: 152.471,
    y2: 230.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_60_334",
    x1: 225.064,
    y1: 297.69,
    x2: 196.076,
    y2: 215.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_60_334",
    x1: 180.684,
    y1: 341.678,
    x2: 192.252,
    y2: 337.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_60_334",
    x1: 234.106,
    y1: 324.692,
    x2: 245.871,
    y2: 320.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_60_334",
    x1: 201.775,
    y1: 350.007,
    x2: 177.792,
    y2: 349.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_60_334",
    x1: 234.196,
    y1: 338.13,
    x2: 257.74,
    y2: 323.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_60_334",
    x1: 340.704,
    y1: 287.264,
    x2: 351.822,
    y2: 283.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_60_334",
    x1: 278.223,
    y1: 298.912,
    x2: 289.345,
    y2: 294.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_60_334",
    x1: 343.333,
    y1: 304.32,
    x2: 362.933,
    y2: 279.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_60_334",
    x1: 267.542,
    y1: 306.774,
    x2: 300.776,
    y2: 306.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_60_334",
    x1: 407.665,
    y1: 190.299,
    x2: 414.887,
    y2: 153.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_60_334",
    x1: 291.773,
    y1: 194.929,
    x2: 255.762,
    y2: 240.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_60_334",
    x1: 259.146,
    y1: 229.223,
    x2: 280.049,
    y2: 221.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_60_334",
    x1: 279.433,
    y1: 226.043,
    x2: 297.005,
    y2: 219.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_60_334",
    x1: 253.2,
    y1: 220.83,
    x2: 259.388,
    y2: 218.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_60_334",
    x1: 246.613,
    y1: 186.244,
    x2: 252.345,
    y2: 209.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_60_334",
    x1: 256.754,
    y1: 187.452,
    x2: 258.619,
    y2: 195.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_60_334",
    x1: 255.73,
    y1: 214.642,
    x2: 266.758,
    y2: 210.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_60_334",
    x1: 261.646,
    y1: 217.788,
    x2: 266.205,
    y2: 215.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_60_334",
    x1: 261.807,
    y1: 214.188,
    x2: 266.371,
    y2: 211.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_60_334",
    x1: 264.883,
    y1: 213.893,
    x2: 269.442,
    y2: 211.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_60_334",
    x1: 264.925,
    y1: 216.555,
    x2: 269.484,
    y2: 214.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 306,
    fill: "white",
    transform: "translate(0 142.917) rotate(-20.6104)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingPurple);
export default __webpack_public_path__ + "static/media/gaming_purple.91b56dd62ffe413761043e3fd98808d8.svg";
export { ForwardRef as ReactComponent };